module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text justify-content-center"
  }, [_c('div', {
    staticClass: "col-6 align-self-center"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Wskazania")]), _vm._v(" "), _c('hr', {
    staticClass: "separator"
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("bezinwazyjny lifting powiek górnych,")]), _vm._v(" "), _c('li', [_vm._v("redukcja zmarszczek nad górna wargą, tzw. “zmarszczek palacza”,")]), _vm._v(" "), _c('li', [_vm._v("redukcja zmarszczek na dolnej powiece,")]), _vm._v(" "), _c('li', [_vm._v("redukcja zmarszczek w kąciku oka tzw. “kurzych łapek”,")]), _vm._v(" "), _c('li', [_vm._v("leczenie wspomagające trądziku oraz usuwanie blizn potrądzikowych,")]), _vm._v(" "), _c('li', [_vm._v("usuwanie brodawek, włókniaków, kępek żółtych oraz plamek rubinowych,")]), _vm._v(" "), _c('li', [_vm._v("leczenie rozstępów oraz blizn pooperacyjnych")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e687259"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing/components/Offer.vue
// module id = 48
// module chunks = 0